import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { CreateDeliveryCSVComponent } from '@components/entities/delivery-notes/create-delivery-csv/create-delivery-csv.component';
import { TransactionDto } from '@dto/transactionDto';
import { DeliveryNote } from '@models/deliveryNote';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormService } from '@services/form/form.service';
import { ToastService } from '@services/toast/toast.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-create-delivery-csv-dialog-content',
  templateUrl: './create-delivery-csv-dialog-content.component.html',
  styleUrls: ['./create-delivery-csv-dialog-content.component.scss']
})
export class CreateDeliveryCSVDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'CreateDeliveryCSVDialogContentComponent';

  public transactions: TransactionDto[];
  public userId: string;
  public customerId: number;

  @ViewChild('createDeliveryCSVComponent') createDeliveryCSVComponent: CreateDeliveryCSVComponent;

  constructor(
    public activeModal: NgbActiveModal,
    public formService: FormService,
    public toastService: ToastService,
    injector: Injector) {
      super(activeModal, injector);
  }

  ngOnInit() {
  }


  newEntityEvent(deliveryNote: DeliveryNote) {
    this.toastService.success($localize`:@@CreateDeliveryNoteSuccessHeader:CSV-Datei erfolgreich gespeichert.`);
    // this.openSuccessDialog();
  }

  openSuccessDialog() {
    Swal.fire({
      title: $localize`:@@CreateDeliveryNoteSuccessHeader:Die CSV-Datei wurde generiert!`,
      text: $localize`:@@CreateDeliveryNoteSuccessText:Die Datei wird automatisch heruntergeladen.`,
      icon: 'success',
      confirmButtonText: $localize`:@@DialogOkButton:OK`,
      confirmButtonColor: 'green'
    });
  }

}
